import _ from 'lodash';
import { createContext, useEffect, useRef, useState } from 'react';

import { readDraft, writeDraft } from './draft';

export const GroupProductContenxt = createContext();

const emptyLabelInfo = {
  productItem: {
    title: '',
    brand: '',
    merchantCode: '',
    hasVariant: false,
    detail: '',
    category: '',
    unit: 'unit',
    hasReturn: false,
    image: '',
    imageOther: [],
    long: '',
    wide: '',
    hight: '',
    volume: '',
    color: '',
    size: '',
    type: '',
    weight: '',
    baseSku: '',
    barCode: '',
    barcodes: [],
    price: '',
    volumeUnit: 'М',
    weightUnit: 'КГ',
    stock: '',
    willExpire: false,
  },
  productVersion: {
    color: '',
    size: '',
    type: '',
    productSku: '',
    price: '',
    stock: '',
  },
};

/**
 * @param {string} [props.draftKey] sessionStorage-ийн key. Дамжуулбал бөглөсөн
 * мэдээлэл refresh хийхэд сэргэнэ. Дамжуулаагүй бол хадгалахгүй.
 */
export const ProductProvider = ({ draftKey, children }) => {
  // Хуудас refresh хийхэд бөглөсөн мэдээлэл сэргэхийн тулд эхлэхдээ л уншина
  const draft = useRef(readDraft(draftKey)).current;

  const [labelInfo, setlabelInfo] = useState(draft.labelInfo ?? emptyLabelInfo);
  const [variantList, setVariantList] = useState(draft.variantList ?? []);
  const [productBaseSku, setProductBaseSku] = useState(draft.productBaseSku ?? null);
  const [productVolume, setProductVolume] = useState(draft.productVolume ?? 0);
  /** Багцад орох дэд бараанууд (тоо ширхэг нь `stock` талбарт) */
  const [selectedProducts, setSelectedProducts] = useState(draft.selectedProducts ?? []);
  /**
   * Формын утгууд — баркод, тоо ширхэг зэрэг нь контекстэд өөрөө бичигддэггүй
   * тул бөглөж байх зуур энд хуулбарлана.
   */
  const [formValues, setFormValues] = useState(draft.formValues ?? {});

  // Төлөв өөрчлөгдөх бүрд draft-ыг шинэчилнэ
  useEffect(() => {
    writeDraft(draftKey, {
      labelInfo,
      variantList,
      productBaseSku,
      productVolume,
      selectedProducts,
      formValues,
    });
  }, [
    draftKey,
    labelInfo,
    variantList,
    productBaseSku,
    productVolume,
    selectedProducts,
    formValues,
  ]);

  const setProductItem = (prop) => (event) => {
    if (event?.target) {
      setlabelInfo({
        ...labelInfo,
        productItem: { ...labelInfo.productItem, [prop]: event.target.value },
      });
    } else {
      setlabelInfo({
        ...labelInfo,
        productItem: { ...labelInfo.productItem, [prop]: event },
      });
    }
  };

  const setProductVersion = (prop) => (event) => {
    if (event.target.value) {
      setlabelInfo({
        ...labelInfo,
        productVersion: {
          ...labelInfo.productVersion,
          [prop]: event.target.value,
        },
      });
    } else {
      setlabelInfo({
        ...labelInfo,
        productVersion: { ...labelInfo.productVersion, [prop]: event },
      });
    }
  };

  const onChooseProductItem = (prop) => {
    setVariantList((oldArray) => [
      ...oldArray,
      {
        title: prop.title,
        productSku: prop.productSku,
        unitPrice: prop.price,
        imageCover: prop.imageCover,
      },
    ]);
  };
  const onChangeBaseSku = (sku) => {
    setProductBaseSku(sku);
  };
  const onChangeProductVolume = (volume) => {
    setProductVolume(volume);
  };

  const changeLevelInfo = (key, subKey, value) => {
    const clone = _.cloneDeep(labelInfo);
    clone[key][subKey] = value;
    setlabelInfo(clone);
  };

  return (
    <GroupProductContenxt.Provider
      value={{
        // Багц үүссэний дараа Add.js нь ЯГ энэ key-г цэвэрлэнэ
        draftKey,
        setProductItem,
        setProductVersion,
        onChooseProductItem,
        labelInfo,
        variantList,
        onChangeBaseSku,
        productBaseSku,
        onChangeProductVolume,
        productVolume,
        changeLevelInfo,
        selectedProducts,
        setSelectedProducts,
        formValues,
        setFormValues,
      }}
    >
      {children}
    </GroupProductContenxt.Provider>
  );
};
